import HiveIcon from '@mui/icons-material/Hive';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CategoryIcon from '@mui/icons-material/Category';
import LzCModule from '@lz-modules/Module';
import PartyModel from './Parties/party.model';
import partyCrudConfig from './Parties/config';
import ItemModel from './Items/item.model';
import itemCrudConfig from './Items/config';

// Create the module and use the customized entities in it
const ParamsModule = new LzCModule({
    ident: 'params',
    name: 'Parameters',
    icon: <HiveIcon />,
    children: [
        { variation: 'Entity', ident: 'parties', icon: <PeopleAltIcon />, modelRef: PartyModel, crud: partyCrudConfig },
        { variation: 'Entity', ident: 'items', icon: <CategoryIcon />, modelRef: ItemModel, crud: itemCrudConfig },
    ],
});

export default ParamsModule;
